<template>
  <div class="countdown">
    <aha-icon
      name="timer"
      width="28"
      height="28"
      viewBox="0 0 24 24"
    ></aha-icon>
    <span ref="timeToAnswer" class="ml-2 mr-3 min-w-16" />
    <span class="countdown-toggler">
      <font-awesome-icon
        icon="plus"
        class="text-xs"
      />
    </span>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Util from '@/util'
import Config from '@/config'
import Socket from '@/socket'
import EventBus from '@/eventBus'

export default {
  data() {
    return {
      countTimeToAnswer: 0,
      requestFrame: null,
      errorUpdateStopSubmission: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },

  watch: {
    'slideActive.stopSubmission': {
      handler(value) {
        this.cancelAnimationFrame()

        if (!value && this.slideActive.hasTimeLimit) {
          this.startCountDownTimeToAnswer()
        }
      },
      immediate: true,
    },
  },

  mounted() {
    if (!this.slideActive.stopSubmission && this.slideActive.hasTimeLimit) {
      this.updateSubmissionTime()
    }

    EventBus.$on('resetTimeToAnswer', () => {
      this.updateSlideActiveAction({
        stopSubmission: false,
      })
      this.updateSubmissionTime()
    })
  },

  destroyed() {
    this.cancelAnimationFrame()
    EventBus.$off('resetTimeToAnswer')
  },

  methods: {
    ...mapActions(['updateSlideActiveAction']),
    enableHoverState() {
      this.isDisableHoverState = false
    },
    setTime(value) {
      this.isDisableHoverState = true

      this.updateSlideActiveAction({
        timeToAnswer: value,
      })
      EventBus.$emit('resetTimeToAnswer')
    },
    updateSubmissionTime() {
      let { stopSubmissionTime } = this.slideActive
      const { stopSubmission, timeToAnswer, hasTimeLimit } = this.slideActive

      if (!stopSubmission && timeToAnswer && hasTimeLimit) {
        stopSubmissionTime =
          Util.getTimeStamp() +
          this.slideActive.timeToAnswer * 1000
        this.updateSlideActiveAction({
          stopSubmissionTime,
        })
      }
      // Update stopSubmissionTime & undo stopSubmission, then start counting
      this.cancelAnimationFrame()
      this.updateSlide(
        {
          stopSubmission: this.slideActive.stopSubmission,
          stopSubmissionTime,
          timeToAnswer: this.slideActive.timeToAnswer,
        },
        (err) => {
          if (!err) {
            this.startCountDownTimeToAnswer()
          }
        },
      )
    },
    // eslint-disable-next-line sonarjs/cognitive-complexity
    startCountDownTimeToAnswer() {
      this.errorUpdateStopSubmission = false
      const self = this

      if (!this.slideActive.hasTimeLimit) return

      this.countTimeToAnswer = parseInt(
        this.slideActive.timeToAnswer,
        10,
      )

      let contextTimeToAnswer = self.$refs.timeToAnswer
      if (contextTimeToAnswer) {
        contextTimeToAnswer.textContent = Util.timeToString(
          self.countTimeToAnswer,
        )
      }

      let secondTime = 0

      function step(timestamp) {
        const timeRun = parseInt(timestamp / 1000, 10)
        if (secondTime !== timeRun) {
          secondTime = timeRun

          self.countTimeToAnswer = parseInt(
            (self.$store.state.slideActive.stopSubmissionTime -
              new Date().getTime()) /
              1000,
            10,
          )
          contextTimeToAnswer = self.$refs.timeToAnswer

          if (contextTimeToAnswer) {
            contextTimeToAnswer.textContent = Util.timeToString(
              self.countTimeToAnswer,
            )
          }
        }

        if (
          !self.$store.state.slideActive.stopSubmission &&
          self.$store.state.slideActive.hasTimeLimit &&
          (!self.countTimeToAnswer || self.countTimeToAnswer <= 0)
        ) {
          self.updateSlideActiveAction({
            stopSubmission: true,
          })
          self.updateSlide({ stopSubmission: true }, (err) => {
            if (err) {
              self.updateSlideActiveAction({
                stopSubmission: false,
              })
            }
            self.cancelAnimationFrame()
          })
        }

        if (self.countTimeToAnswer > 0) {
          self.requestFrame = new Promise((resolve) => {
            requestAnimationFrame(resolve)
          }).then(step)
        } else {
          self.cancelAnimationFrame()
        }
      }
      self.requestFrame = window.requestAnimationFrame(step)
    },

    cancelAnimationFrame() {
      if (this.requestFrame) {
        window.cancelAnimationFrame(this.requestFrame)
      }
    },

    updateSlide(payload, cb) {
      const slideId = this.$store.state.slideActive.id
      const presentationId = this.$store.state.presentation.id
      if (this.$store.state.sharePresentation || !slideId || !presentationId) {
        return
      }

      const data = {
        ...payload,
        socketId: Socket.getSocketId(),
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        presenting: this.$store.getters.isPresenting,
        presentationId,
      }
      this.$store.dispatch('setSyncPresentation', 1)
      // eslint-disable-next-line promise/catch-or-return
      this.$http.put(Config.api.updateSlide + slideId, data).then(
        () => {
          this.$store.dispatch('setSyncPresentation', 2)

          // eslint-disable-next-line promise/always-return
          if (cb) {
            // eslint-disable-next-line promise/no-callback-in-promise
            cb()
          }
        },
        (err) => {
          this.errorUpdateStopSubmission = true
          if (cb && !this.errorUpdateStopSubmission) {
            // eslint-disable-next-line promise/no-callback-in-promise
            cb(err)
          }
        },
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.countdown {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  padding: 4px 16px 4px 8px;

  &-toggler {
    display: flex;
    width: 20px;
    height: 20px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: rgba(#313131, 0.5);
    background: rgba(0, 0, 0, 0.10);
  }
}
</style>
